import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useTodoStore = defineStore('todo', () => {
  const tasks = ref([])
  const types = ref([])
  const cycles = ref([])
  const showTaskModal = ref(false)
  const showSettingsModal = ref(false)
  const editingTask = ref(null)

  // 添加搜索查询状态
  const searchQuery = ref('')

  // 用户价值相关状态
  const userWorth = ref(0)
  const worthHistory = ref([])
  const showWorthHistoryModal = ref(false)

  // 自动更新设置
  const autoUpdateSettings = ref({
    enabled: true, // 默认启用自动更新
    checkInterval: 30000, // 默认30秒检查一次
    lastCheck: null
  })

  // 计算活跃任务（排除已删除的任务）
  const activeTasks = computed(() => {
    return tasks.value.filter(task => task.is_active)
  })

  // 计算已完成的活跃任务数量
  const completedActiveTasksCount = computed(() => {
    return activeTasks.value.filter(task => task.completed).length
  })

  // 计算活跃任务的完成率
  const activeTasksCompletionRate = computed(() => {
    if (activeTasks.value.length === 0) return 0
    return Math.round((completedActiveTasksCount.value / activeTasks.value.length) * 100)
  })

  // 计算筛选后的任务（包括搜索功能）
  const filteredTasks = computed(() => {
    if (!searchQuery.value) {
      return tasks.value
    }

    const query = searchQuery.value.toLowerCase()
    return tasks.value.filter(task =>
      task.title.toLowerCase().includes(query) ||
      task.description.toLowerCase().includes(query)
    )
  })

  // 更新任务列表
  function updateTasks(newTasks) {
    tasks.value = newTasks
  }

  // 更新任务类型
  function updateTypes(newTypes) {
    types.value = newTypes
  }

  // 更新任务周期
  function updateCycles(newCycles) {
    cycles.value = newCycles
  }

  // 切换任务完成状态
  function toggleTask(taskId) {
    const task = tasks.value.find(t => t.id === taskId)
    if (task) {
      task.completed = !task.completed
    }
  }

  // 更新用户价值
  function updateUserWorth(worth) {
    userWorth.value = worth
  }

  // 更新价值历史记录
  function updateWorthHistory(history) {
    worthHistory.value = history
  }

  // 打开价值历史记录模态框
  function openWorthHistoryModal() {
    showWorthHistoryModal.value = true
  }

  // 关闭价值历史记录模态框
  function closeWorthHistoryModal() {
    showWorthHistoryModal.value = false
  }

  // 打开添加任务模态框
  function openAddTaskModal() {
    editingTask.value = null
    showTaskModal.value = true
  }

  // 打开编辑任务模态框
  function openEditTaskModal(task) {
    editingTask.value = task
    showTaskModal.value = true
  }

  // 关闭任务模态框
  function closeTaskModal() {
    showTaskModal.value = false
    editingTask.value = null
  }

  // 打开设置模态框
  function openSettingsModal() {
    showSettingsModal.value = true
  }

  // 关闭设置模态框
  function closeSettingsModal() {
    showSettingsModal.value = false
  }

  // 更新自动更新设置
  function updateAutoUpdateSettings(settings) {
    autoUpdateSettings.value = {
      ...autoUpdateSettings.value,
      ...settings
    }
  }

  // 自动更新任务（用于周期性任务的自动重置）
  function autoUpdateTasks() {
    // 这里应该实现周期任务的自动更新逻辑
    // 返回更新的任务数量
    console.log('执行自动更新任务')
    return 0 // 暂时返回0，表示没有更新任何任务
  }

  return {
    tasks,
    types,
    cycles,
    showTaskModal,
    showSettingsModal,
    editingTask,
    autoUpdateSettings,
    userWorth,
    worthHistory,
    showWorthHistoryModal,
    searchQuery, // 导出搜索查询状态
    activeTasks,
    completedActiveTasksCount,
    activeTasksCompletionRate,
    filteredTasks, // 导出筛选后的任务
    updateTasks,
    updateTypes,
    updateCycles,
    toggleTask,
    updateUserWorth,
    updateWorthHistory,
    openWorthHistoryModal,
    closeWorthHistoryModal,
    openAddTaskModal,
    openEditTaskModal,
    closeTaskModal,
    openSettingsModal,
    closeSettingsModal,
    updateAutoUpdateSettings,
    autoUpdateTasks
  }
})